import { Accordion, AccordionDetails, AccordionSummary, LinearProgress, Pagination, PaginationItem } from "@mui/material";
import { ArrowBack, Arrowdown2, Cancel, Forward } from "../../../assets";
import { Button, CustomModal, Dropdown, Input, Layout, FilterInput, TableRowResponsive, EmptyTable } from "../../components";
import { InstallmentController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import moment from "moment-jalaali";


class Installment extends InstallmentController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getList()
  }
  render() {

    const {loading} = this.state;
    return (
      <Layout title="اقساط سررسیده شده">
        <Helmet>
          <title> اقساط سررسیده شده | بیمه زندگی هامرز </title>
        </Helmet>

        {loading ? 
                <LinearProgress />
                :
                <>
        <FilterInput buttonTitle="فیلتر ها" placeholder="فیلتر های اقساط سررسیده شده" onClick={() => this.setState({ openModal: !this.state.openModal })} str={this.state.str} />

        <div className="installment table-responsive scrollbar ">
          <table className="table hide-mobile">
            <thead>
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">نام و نام خانوادگی</th>
                <th scope="col">شماره موبایل </th>
                <th scope="col">شماره بیمه نامه </th>
                <th scope="col">مبلغ کل  </th>
                <th scope="col">تاریخ سررسید</th>
              </tr>
            </thead>
            <tbody>
              {this.state.installment?.list?.length > 0 && this.state.installment?.list?.map((item: any, index: number) => {
                return (

                  <tr>
                    <th>{index + 1}</th>
                    <td>{item?.policy_holder_full_name}</td>
                    <td>{item?.mobile}</td>
                    <td>{item?.policy_id}</td>
                    <td>{item?.total_amount}</td>
                    <td>{moment(`${item?.date}`, 'YYYY-M-D').format('jYYYY/jM/jD')}</td>

                  </tr>
                )
              })}
            </tbody>
          </table>
          {this.state.installment?.list?.length > 0 ? <>
            {this.state.installment?.list?.map((item: any, index: number) => {
              return (
                <>

                  <Accordion className="policy-accordion hide-desktop">
                    <AccordionSummary
                      expandIcon={<img alt="هامرز" src={Arrowdown2} />}
                      aria-controls="panel1a-content"
                      className="summsry"
                      id="panel1a-header"
                    >
                      <TableRowResponsive title="ردیف" value={index + 1} />
                      <TableRowResponsive title="نام و نام خانوادگی" value={item?.policy_holder_full_name} />
                      <TableRowResponsive title=" شماره موبایل	 " value={item?.mobile} />
                    </AccordionSummary>
                    <AccordionDetails
                      className="d-flex flex-wrap"
                    >
                      <TableRowResponsive title="شماره بیمه نامه	" value={item?.policy_id} />
                      <TableRowResponsive title=" مبلغ کل   " value={item?.total_amount} />
                      <TableRowResponsive title=" تاریخ سررسید " value="1402/07/24" />


                    </AccordionDetails>
                  </Accordion>
                </>

              )
            })}
            <Pagination
              className="custom-pagination"
              count={this.state.installment?.total ? Math.ceil(this.state.installment?.total / 10) : 1}
              onChange={this.handleChangePage}
              size="small"
              renderItem={(item) => (
                <PaginationItem
                  slots={{ previous: Forward, next: ArrowBack }}
                  {...item}
                />
              )}
            />
          </>
            :
            <EmptyTable title="اطلاعاتی برای نمایش وجود ندارد" />
          }

        </div>
        <CustomModal openModal={this.state.openModal} onClose={() => this.setState({ openModal: !this.state.openModal })}>
          <>
            <div className="custom-modal-main-title hide-desktop">
              <h1 className="title">
                فیلتر های کارمزد ها
              </h1>
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() => this.setState({ openModal: !this.state.openModal })} />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                  فیلتر های اعلام شده :
                </span>{" "}
              </div>
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() => this.setState({ openModal: !this.state.openModal })} />
            </div>
            <h2 className="custom-modal-title">
              بر اساس اطلاعات بیمه گذار
            </h2>
            <div className="custom-modal-row">
              <Input myStyle="custom-modal-item" title="نام بیمه گذار " value={this.state.name} onChange={this.handleChange} />
              <Input myStyle="custom-modal-item" title="نام خانوادگی بیمه گذار" value={this.state.family} onChange={this.handleChange} />
              <Input myStyle="custom-modal-item" title="کد ملی بیمه گذار" value={this.state.nationalCode} onChange={this.handleChange} />
            </div>
            <h2 className="custom-modal-title mt-33">
              بر اساس اطلاعات بیمه
            </h2>
            <div className="custom-modal-row ">
              <Input myStyle="custom-modal-item" title="شماره بیمه نامه" value={this.state.insurancePolicyNumber} onChange={this.handleChange} />
              <Input myStyle="custom-modal-item" title="نوع بیمه نامه" value={this.state.value} onChange={this.handleChange} />
              <Dropdown myStyle="custom-modal-item" title="وضعیت بیمه نامه" value={this.state.value} onChange={this.handleChange} />
            </div>
            <div className="custom-modal-row ">

              <Dropdown myStyle="custom-modal-item" title="وضعیت" value={this.state.value} onChange={this.handleChange} />
            </div>
            <div className="custom-modal-confirm">
              <Button myStyle="bg-green" title="اعمال" onClick={()=>{}}/>
            </div>

          </>
        </CustomModal>

        </>
        }
      </Layout>
    )
  }
}
export default Installment;